import React, { useState, useRef, useEffect } from "react";
import {
    Box,
    useTheme,
    Button,
    Modal,
    TextField,
    DialogActions,
    DialogContent,
    DialogContentText,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    CircularProgress,
    IconButton,
} from "@mui/material";

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

// import { styled } from '@mui/material/styles';

import { DataGrid, GridApi } from "@mui/x-data-grid";

import { useGetYogaEmpowerCategoriesQuery, useCreateYogaEmpowerCategoriesMutation, useUpdateYogaEmpowerCategoriesMutation, useDeleteYogaEmpowerCategoriesMutation } from "state/api";
import { Header } from "components";




const YogaEmpowerCategories = () => {

    const { data, isLoading, refetch } = useGetYogaEmpowerCategoriesQuery();

    console.log("YogaEmpowerCategories data:", data);


    const [createYogaEmpowerCategories] = useCreateYogaEmpowerCategoriesMutation();
    const [updateYogaEmpowerCategories] = useUpdateYogaEmpowerCategoriesMutation();
    const [deleteYogaEmpowerCategories] = useDeleteYogaEmpowerCategoriesMutation();


    const theme = useTheme();

    const gridApiRef = useRef(null);

    useEffect(() => {
        // Access grid API when it's ready
        if (gridApiRef.current) {
            const api = gridApiRef.current;
            // Perform any actions needed with the grid API here
            // For example, you could set initial selected rows:
            api.setSelectedRows([0]);
        }
    }, [gridApiRef]);

    // data columns
    const columns = [
        // {
        //   field: "_id",
        //   headerName: "ID",
        //   flex: 1,
        // },
        {
            field: "name",
            headerName: "Yoga/Empower Categories Title",
            flex: 1,
            // editable: true,
        },
        // {
        //   field: "description",
        //   headerName: "YogaEmpowerCategories Description",
        //   flex: 1,
        //   // editable: true,
        // },

        {
            field: "actions",
            headerName: "Actions",
            flex: 0.5,
            renderCell: (params) => {
                const { _id } = params.row;
                console.log("Row data:", _id);
                return (
                    <div>
                        <IconButton
                            color="primary"
                            aria-label="edit"
                            onClick={() => handleOpenEdit(_id)}
                        >
                            <EditIcon sx={{ color: 'white' }} />
                        </IconButton>
                        <IconButton
                            color="error"
                            aria-label="delete"
                            onClick={() => handleDeleteYogaEmpowerCategories(_id)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </div>
                );
            },
        },
    ];

    const [open, setOpen] = useState(false);
    const [name, setname] = useState("");
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [user, setUser] = useState(null);
    const [nameError, setnameError] = useState(null);
    const [YogaEmpowerCategoriesCategory, setYogaEmpowerCategoriesCategory] = useState("YogaEmpowerCategories"); // Initial selection
    const [YogaEmpowerCategoriesCategoryError, setYogaEmpowerCategoriesCategoryError] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState(null);
    const [descriptionError, setdescriptionError] = useState(null);
    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false); // State for loading indicator
    const [selectedEditRowData, setSelectedEditRowData] = useState(null); // Add this state to store the selected row's data

    const [YogaEmpowerCategoriesEditError, setYogaEmpowerCategoriesEditError] = useState(null);


    // New state to track the modified fields
    const [modifiedFields, setModifiedFields] = useState({});

    const handlenameChange = (event) => {
        setname(event.target.value);
        // Update the modified fields
        // setModifiedFields({ ...modifiedFields, name: selectedEditRowData.name });
        setModifiedFields({ ...modifiedFields, name: event.target.value });

        setnameError(event.target.value ? null : "Enter Yoga/Empower Categories name");
    };

    const handleCategoryChange = (event) => {
        setYogaEmpowerCategoriesCategory(event.target.value);
        // Update the modified fields
        // setModifiedFields({ ...modifiedFields, YogaEmpowerCategoriesCategory: selectedEditRowData.YogaEmpowerCategoriesCategory });
        setModifiedFields({ ...modifiedFields, YogaEmpowerCategoriesCategory: event.target.value });

        setYogaEmpowerCategoriesCategoryError(event.target.value ? null : "Please select a category");
    };



    const handleSubmit = async () => {
        console.log("working");
        // ... other logic

        if (!name) {
            setnameError("Enter Yoga/Empower Categories name");
            return;
        }


        // if (!description) {
        //   setdescriptionError("Enter YogaEmpowerCategories description");
        //   return;
        // }

        setIsLoadingSubmit(true); // Start loading before asynchronous operations
        const updateData = {
            name: name,
        };
        console.log("206 working");
        await createYogaEmpowerCategories(updateData);

        setIsLoadingSubmit(false); // Stop loading after data is created

        setOpen(false); // Close the modal after successful submission

        refetch();
    };


    const handleOpenEdit = (id) => {

        const selectedRow = data.data.find((row) => row._id === id);

        if (selectedRow) {
            setname(selectedRow.name || "");
            setSelectedEditRowData(selectedRow);

            // Set the modified fields to an empty object initially
            setModifiedFields({});

            setOpen(true);
        }
    };


    const handleEditSubmit = async () => {
        // Only send the modified fields to the API
        if (Object.keys(modifiedFields).length > 0) {


            setIsLoadingSubmit(true); // Start loading before asynchronous operations


            const { selectedFile, ...rest } = modifiedFields;


            const editedYogaEmpowerCategoriesData = {
                id: selectedEditRowData._id,
                ...modifiedFields,
            };


            await updateYogaEmpowerCategories(editedYogaEmpowerCategoriesData);
            setModifiedFields({});
            setSelectedEditRowData(null);

            setIsLoadingSubmit(false);

            setOpen(false);
            refetch();
        }
        else {
            setYogaEmpowerCategoriesEditError("Edit a value first");
            return;
        }

        // Rest of the code...
    };

    const handleDeleteYogaEmpowerCategories = async (catId) => {
        console.log("Delete ID:", catId);

        if (window.confirm("Are you sure you want to delete this Yoga/Empower Categories?")) {
            try {
                // await deleteYogaEmpowerCategories.mutateAsync(id);
                // await deleteYogaEmpowerCategories(id);
                await deleteYogaEmpowerCategories({ id: catId }).unwrap();
                refetch(); // Reload to reflect changes in the UI
            } catch (error) {
                console.error("Error deleting Yoga/Empower Categories:", error);
            }
        }
    };

    return (
        <Box m="1.5rem 2.5rem">
            {/* Header */}
            {/* <Header title="YogaEmpowerCategories" subtitle="List of YogaEmpowerCategories" /> */}
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="Yoga/Empower Categories" subtitle="List of Yoga/Empower Categories" />
                <Button variant="contained" color="primary" size="medium" onClick={handleOpen}>
                    {'Add Yoga/Empower Categories'}
                </Button>
            </Box>

            {/* Content */}
            <Box
                mt="40px"
                height="75vh"
                sx={{
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: theme.palette.background.alt,
                        color: theme.palette.secondary[100],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: theme.palette.primary.light,
                    },
                    "& .MuiDataGrid-footerContainer": {
                        backgroundColor: theme.palette.primary.light,
                        color: theme.palette.secondary[100],
                        borderTop: "none",
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButtom-text": {
                        color: `${theme.palette.secondary[200]} !important`,
                    },
                }}
            >
                {/* Grid table */}
                <DataGrid
                    loading={isLoading || !data.data}
                    getRowId={(row) => row._id}
                    rows={data !== undefined ? data.data : []}
                    columns={columns}

                />
            </Box>


            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    minWidth: 500, // Adjust the minimum width for your modal
                    p: 4, // Add padding inside the modal
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper', // Set white background
                    borderRadius: 2,           // Add rounded borders (adjust the value)
                    boxShadow: 24
                }}>

                    <DialogContent>
                        {/* Error messages */}
                        {nameError && <Typography variant="caption" color="error">{nameError}</Typography>}
                        {selectedFileError && <Typography variant="caption" color="error">{selectedFileError}</Typography>}
                        {YogaEmpowerCategoriesEditError && <Typography variant="caption" color="error">{YogaEmpowerCategoriesEditError}</Typography>}

                        <DialogContentText>
                            {!selectedEditRowData ? "Add a new Yoga/Empower Categories" : "Edit Yoga/Empower Categories"}
                        </DialogContentText>
                        <TextField
                            label="Yoga/Empower Categories Name"
                            value={name}
                            onChange={handlenameChange}
                            error={!!nameError} // Set error prop based on error state
                            helperText={nameError} // Set helper text for error display
                            fullWidth
                            margin="normal"
                        />
                        <br />

                        <br />

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Cancel
                        </Button>
                        {/* <Button onClick={handleSubmit} color="primary">
              Save
            </Button> */}

                        <Button onClick={!selectedEditRowData ? handleSubmit : handleEditSubmit} color="primary" disabled={isLoadingSubmit}>
                            {isLoadingSubmit ? <CircularProgress size="medium" style={{ width: 20, height: 20, color: 'white' }} /> : 'Save'}
                            {/* Save */}
                        </Button>

                    </DialogActions>
                </Box>
            </Modal>
        </Box>
    );
};

export default YogaEmpowerCategories;
